import axios from "axios";
import { getCaid } from "@/data/regionInfo";
// Add a request interceptor

axios.interceptors.request.use((config) => {
    const caid = getCaid() ? getCaid().caid : null;
    if(caid) config.params = {...config.params, caid};
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default axios;